/**
 * Admin-mounted audit config paths (templates + materials).
 * Kept in the audit module so report-definition screens share one source of truth.
 */
export const ADMIN_AUDIT_ROOT = '/admin/audit';

/** Default template chip when visiting `/admin/audit/templates`. */
export const ADMIN_AUDIT_DEFAULT_TEMPLATE_TYPE = 'AUDIT_GIP_STATUS';

export const adminAuditPaths = {
  /** Default entry for legacy redirects — first template type chip. */
  root: () => `${ADMIN_AUDIT_ROOT}/templates/${ADMIN_AUDIT_DEFAULT_TEMPLATE_TYPE}`,
  templates: () => `${ADMIN_AUDIT_ROOT}/templates`,
  templatesByType: (reportType: string) => `${ADMIN_AUDIT_ROOT}/templates/${reportType}`,
  materials: () => `${ADMIN_AUDIT_ROOT}/materials`,
  /** Chip URL for a report type’s template list. */
  reportDefinitions: (reportType: string) => `${ADMIN_AUDIT_ROOT}/templates/${reportType}`,
  reportDefinitionDefault: (reportType: string) =>
    `${ADMIN_AUDIT_ROOT}/templates/${reportType}/default`,
  reportDefinitionById: (id: string) => `${ADMIN_AUDIT_ROOT}/templates/by-id/${id}`,
};
